import { useEffect, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { Button, Card, CardBody, Autocomplete, AutocompleteItem, } from "@heroui/react"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_PAGEACTION_TYPE, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import NextUITable, { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit, faFilter, faMagnifyingGlass, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { resetDetail, setItemDetail, setNewEntryMode } from "../../state/itemSlice"
import ConfirmBox from "../../components/ConfirmBox"

const ItemMaster = () => {
    const { token, user } = useSelector((state) => state.auth)
    const { yearId } = useSelector((state) => state.company)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedGroup, setSelectedGroup] = useState("")
    const [selectedMade, setSelectedMade] = useState("")
    const [selectedCategory, setSelectedCategory] = useState("")
    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")

    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "ITEM_CODE",
        "ITEM_DESC",
        "CAT",
        "ITEM_TYPE_NAME",
        "ITGR_NAME",
        'ITEM_STATUS'

    ]

    const exportColumns = [

        {
            name: "ITEM CODE",
            uid: "ITEM_CODE",
        },
        {
            name: "DESCRIPTION",
            uid: "ITEM_DESC",
        },
        {
            name: "CATEGORY",
            uid: "CAT",
        },
        {
            name: "TYPE",
            uid: "ITEM_TYPE_NAME",
        },
         {
            name: "GROUP",
            uid: "ITGR_NAME",
        },
        {
            name: "STATUS",
            uid: "ITEM_STATUS",
        },


    ]

    const onSuccessDelete = (data) => {
        setItemToDelete("")
        filterItem({
            data: {
                item_code: '',
                group_code: '',
                made: '',
                category: ''
            }
        })
        toast.success("Item Deleted",
            {
                position: "top-center"
            })
    }

    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.item.masterData,
        queryKey: "fetchMasterData"
    })

    const { mutate: FndeleteItem } = usePost(
        {
            url: apiRoute.item.deleteitem,
            query: "delete-item",
            onSuccessTasks: onSuccessDelete
        }
    )

    const onSuccessTasks = () => {
    }

    const { isPending, isError, data = [], mutate: filterItem } = usePost({
        url: apiRoute.item.fetch,
        queryKey: "fetchItemMaster",
        onSuccessTasks

    })
    const funLoadData = () => {
        filterItem({
            data: {
                item_code: '',
                group_code: '',
                made: '',
                category: ''
            }
        })
        setSelectedCategory("")
        setSelectedGroup("")
        setSelectedMade("")
    }

    useEffect(() => {
        funLoadData();
    }, [])

    let downloadDataFooter = {
        ITEM_CODE: "",
        ITEM_DESC: "",
        CAT: "",
        ITEM_TYPE_NAME: "",
        ITGR_NAME:"",
        ITEM_STATUS: ""

    }
    if (isError) {
        return <ErrorCard />
    }
    // if (isPending) {
    //     retu


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "ITEM CODE",
            uid: "ITEM_CODE",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "DESCRIPTION",
            uid: "ITEM_DESC",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "CATEGORY",
            uid: "CAT",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "TYPE",
            uid: "ITEM_TYPE_NAME",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Group",
            uid: "ITGR_NAME",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "STATUS",
            uid: "ITEM_STATUS",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },


    ]

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    token: token,
                    itemcode: row.ITEM_CODE,
                    db_user: GetLoginCredentialDb(user, yearId)
                }
                setItemToEdit(obj)
                // dispatch(setItemDetail(obj))
                // dispatch(setNewEntryMode(false))
                // navigate(linksUrl.master.item.createItemMaster)
            },
            type: ROW_ACTION_BTN_TYPE.link
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete(row.ITEM_CODE)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

    ]
    const handleFilter = () => {
        filterItem({
            data: {
                item_code: '',
                group_code: selectedGroup ? selectedGroup : "",
                made: selectedMade ? selectedMade : "",
                category: selectedCategory ? selectedCategory : ""
            }
        })
    }
    const handleResetFilter = () => {
        funLoadData();
    }
    const handleAddNew = () => {

        navigate(linksUrl.master.item.createItemMaster);
        dispatch(resetDetail())
    }

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete && itemToDelete != null) {
                FndeleteItem({
                    data: {
                        item_code: itemToDelete,
                    }
                })
            }
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                dispatch(setItemDetail(itemToEdit))
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.master.item.createItemMaster)
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }


    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <div>


            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
            <MainContainer pageName="Items" info={[]} breadcrumbs={["Master", "Item Master"]} >

                <div className="" style={{ textAlign: "right" }}>

                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}
                    >
                        Add New
                    </Button>
                </div>

                <Card shadow="sm" radius="sm" className="mb-3 h-full">
                    <CardBody className="p-2">
                        <div className="flex flex-wrap items-center gap-2">
                            {/* date */}

                            <Autocomplete
                                size="sm"
                                label="Group"
                                className="max-w-40"
                                defaultItems={
                                    masterData && masterData.itemGroup
                                        ? masterData.itemGroup
                                        : []
                                }
                                isVirtualized
                                variant="bordered"
                                color="warning"
                                selectedKey={selectedGroup}
                                onSelectionChange={setSelectedGroup}
                            >
                                {(item) => (
                                    <AutocompleteItem key={item.ITGR_CODE}>
                                        {item.ITGR_NAME}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>

                            <Autocomplete
                                size="sm"
                                label="Made"
                                className="max-w-36"
                                defaultItems={
                                    masterData && masterData.itemMade
                                        ? masterData.itemMade
                                        : []
                                }
                                isVirtualized
                                selectedKey={selectedMade}
                                variant="bordered"
                                color="warning"
                                onSelectionChange={setSelectedMade}
                            >
                                {(item) => (
                                    <AutocompleteItem key={item.made}>
                                        {item.made}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                            <Autocomplete
                                size="sm"
                                label="Category"
                                className="max-w-36"
                                defaultItems={masterData && masterData.itemCategory
                                    ? masterData.itemCategory
                                    : []}
                                isVirtualized
                                variant="bordered"
                                color="warning"
                                selectedKey={selectedCategory}
                                onSelectionChange={setSelectedCategory}
                            >
                                {(item) => (
                                    <AutocompleteItem key={item.CAT}>
                                        {item.CAT}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>

                            <Button
                                size="sm"
                                color="primary"
                                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                                onPress={handleFilter}
                            >
                                Search
                            </Button>

                            <Button
                                size="sm"
                                color="primary"
                                startContent={<FontAwesomeIcon icon={faFilter} />}
                                onPress={handleResetFilter}
                            >
                                Reset
                            </Button>
                        </div>
                    </CardBody>
                </Card>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="Item-master-List"
                    showAdvanceFilter={false}
                    id="ITEM_CODE"
                ></NextUITable>
            </MainContainer >
        </div >
    )
}
export default ItemMaster